import { LoginResponseError, ValidationErrors } from 'AppShell/appshell_types';

const isValidationError = (loginError: ValidationErrors | LoginResponseError | Error): loginError is ValidationErrors =>
    !(loginError instanceof Error) && !Array.isArray(loginError);

export const getValidationErrors = (loginError: LoginResponseError | ValidationErrors | Error) => {
    if (isValidationError(loginError)) {
        return {
            email: loginError?.email,
            password: loginError?.password,
        };
    }
    return {};
};
